import React from "react";
import TextMenuPage from "../components/TextMenuPage";
import alcoholSections from "../data/alcohol_sections.json";
import { useI18n } from "../data/i18n";

const AlcoholMenu = () => {
  const { t, lang } = useI18n(); // Добавете lang
  
  // Вземете секциите за текущия език
  const sections = alcoholSections[lang] || alcoholSections.bg;
  
  return (
    <TextMenuPage
      label={t("menu.alcohol")}
      title={t("menu.alcohol")}
      sections={sections}
    />
  );
};

export default AlcoholMenu;